module.exports = __webpack_public_path__ + "static/media/A21_CNG.f1cdff0e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/tco/assets/A21_CNG.jpg
// module id = 1484
// module chunks = 0